module.exports = __webpack_public_path__ + "img/id_demo_f.050562ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/id_demo_f.jpg
// module id = ZbDz
// module chunks = 1